import { RefObject, useEffect } from 'react';

import { AttentionBlock } from '@/store';
import { rotatePoint } from '@/utils';

export const useAttentionMap = (
  canvasRef: RefObject<HTMLCanvasElement | null>,
  attention?: AttentionBlock[],
  rotation: number = 0,
  canvasVersion: number = 0
) => {
  useEffect(() => {
    let frameId: number | null = null;

    if (frameId != null) cancelAnimationFrame(frameId);

    frameId = requestAnimationFrame(() => {
      if (!attention || !canvasVersion) return;

      const canvas = canvasRef.current;
      if (!canvas) return;

      const context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) return;

      const dpr = window.devicePixelRatio || 1;
      const width = Math.round(canvas.width / dpr);
      const height = Math.round(canvas.height / dpr);

      context.setTransform(dpr, 0, 0, dpr, 0, 0);
      context.clearRect(0, 0, width, height);

      const rotatedAttention = attention.map((block) => ({
        ...block,
        points: block.points.map((p) => {
          return rotatePoint(p, rotation);
        }),
      }));

      for (const block of rotatedAttention) {
        const alpha = Math.floor(128 * Math.min(block.intensity, 1.0))
          .toString(16)
          .padStart(2, '0');
        context.fillStyle = '#8DFF30' + alpha;
        context.beginPath();

        for (const [i, point] of block.points.entries()) {
          const px = point.x * width;
          const py = point.y * height;
          if (i === 0) {
            context.moveTo(px, py);
          } else {
            context.lineTo(px, py);
          }
        }

        context.closePath();
        context.fill();
      }
    });

    return () => {
      if (frameId != null) cancelAnimationFrame(frameId);
    };
  }, [attention, rotation, canvasRef, canvasVersion]);
};
